import React from 'react';
import { Typography, Button, Card, CardActions, CardContent, CardMedia } from '@material-ui/core';

import useStyles from './styles';

const CartItem = ({item, onUpdateCartQty, onRemoveFromCart}) => {
    const classes = useStyles();
  return (
    <Card>
        <CardMedia component="img" image={item.image.url} alt={item.name} classes={classes.media}/>
        <CardContent className={classes.CardContent}>
            <Typography variant="h5">{item.name}</Typography>
            <Typography variant="h6">{item.line_total.formatted_with_symbol}</Typography>
        </CardContent>
        <CardActions className={classes.CardActions}>
            <div className={classes.buttons}>
                <Button type="button" size="small"onClick={() => onUpdateCartQty(item.id, item.quantity -1)}>-</Button>
                <Typography>{item.quantity}</Typography>
                <Button type="button" size="small"onClick={() => onUpdateCartQty(item.id, item.quantity +1)}>+</Button>
            </div>
            <Button variant="contained" type="button" color="secondary" onclick={() => onRemoveFromCart(item.id)}>Remove</Button>
        </CardActions>
    </Card>
  )
}

export default CartItem
